import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { useStore } from '../../../../hooks/useStore';
import CreateImportStore from '../store/createImportStore';

const store = new CreateImportStore();
const CreateImportContext = createContext(store);

export const CreateImportContextProvider: FC<PropsWithChildren> = ({ children }) => {
  return <CreateImportContext.Provider value={store}>{children}</CreateImportContext.Provider>;
};

export const useCreateImport = () => {
  const { employeeStore } = useStore();
  const newImport = useContext(CreateImportContext);

  const createImport = async () => {
    const request = newImport.buildImportObject();
    if (request) {
      if (newImport.type === 'employees') return employeeStore.importEmployees(request);
    }
    return undefined;
  };
  return { newImport, createImport };
};
